import axios from '../../axios';
import { toast } from 'react-toastify';
import { ADD_MODEL, DELETE_MODEL, GET_MODEL, UPDATE_MODEL, GET_ONE_MODEL } from '../types';

export const getModel =
  ({ page, limit, search, sortBy, sortOrder }) =>
  async (dispatch) => {
    try {
      const res = await axios.get('/model/all', {
        params: {
          page,
          limit,
          search,
          sortBy,
          sortOrder,
        },
      });

      if (res.data.code === 1) {
        dispatch({ type: GET_MODEL, payload: res.data.data });
      }
    } catch (err) {
      if (err.response.data.errors[0].message) {
        toast.error(err.response.data.errors[0].message);
      }
      // console.error('Failed to get Model. Please try again. :', err);
    }
  };

export const addModel = (formData) => async (dispatch) => {
  try {
    const res = await axios.post('/model/add', formData);

    if (res.data.code === 1) {
      dispatch({ type: ADD_MODEL, payload: res.data.data });
      setTimeout(() => {
        toast.success('Model added successfully!');
      }, 1000);
    }
    if (res.data.code === 0) {
      setTimeout(() => {
        toast.error(res.data.message);
      }, 1000);
    }
  } catch (err) {
    if (err.response.data.errors[0].message) {
      toast.error(err.response.data.errors[0].message);
    }
  }
};

export const updateModel = (formData) => async (dispatch) => {
  try {
    const res = await axios.post(`/model/update`, formData);

    if (res.data.code === 1) {
      dispatch({ type: UPDATE_MODEL, payload: res.data.data });

      setTimeout(() => {
        toast.success('Model updated successfully!');
      }, 1000);
    }
  } catch (err) {
    if (err.response.data.errors[0].message) {
      toast.error(err.response.data.errors[0].message);
    }
    // toast.error('Failed to update Model. Please try again.');
  }
};

// Delete Model
export const deleteModel = (id) => async (dispatch) => {
  try {
    if (!id) {
      toast.error('Please select any record');
      return false;
    }
    const res = await axios.post(`/model/delete/${id}`);
    if (res.data.code === 1) {
      dispatch({ type: DELETE_MODEL, payload: { id } });
      toast.success('Model deleted successfully!');
    }
  } catch (err) {
    if (err.response.data.errors[0].message) {
      toast.error(err.response.data.errors[0].message);
    }
    // toast.error('Failed to delete Model. Please try again.');
  }
};

export const getSingleModel = (id) => async (dispatch) => {
  try {
    const res = await axios.get(`/model/${id}`);
    if (res.data.code === 1) {
      dispatch({ type: GET_ONE_MODEL, payload: res.data.data });
    }
  } catch (err) {
    console.error('Failed to get item by finish item. Please try again.');
    if (err.response.data.message) {
      toast.error(err.response.data.message);
    }
  }
};